import { useContext, useEffect, useState } from 'react';

import { FapAppContext } from '../../../context/fap-app.context';
import contractorPropsController from './contractorPropsController';
import distanceToLocalStr from '../../../utils/distanceToLocal';

import ContinueSearch from '../../../Components/Organisms/ContinueSearch';

const ContinueSearchContainer = ({
  filtersState,
  index,
  facets,
  maxRadius,
  onCtaClick,
}) => {
  const [results, setResult] = useState(null);
  const {
    selectedCategory: savedCategory,
    selectedLocation: savedLocation,
    agentServices,
    qualifications,
  } = useContext(FapAppContext);
  useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let ignore = false;
    index
      .search('', {
        page: 0,
        hitsPerPage: 2,
        facets,
        facetFilters: [
          ...filtersState?.field_agent_services,
          ...filtersState?.certifications,
        ],
        aroundLatLng: filtersState?.location,
        aroundRadius: maxRadius,
      })
      .then((res) => {
        setResult(res);
      });
    return () => {
      ignore = true;
    };
  }, [
    filtersState.field_agent_services,
    filtersState.location,
    filtersState.certifications,
  ]);
  const continueSearchProps = {
    title: Drupal.t('Continue your search'),
    zipCode: savedLocation[0]?.address_components[0].short_name,
    productCategory: savedCategory.label,
    isFap: true,
    extra: ['listing__no-results-continue-search'],
    contractors:
      results && results.hits.length > 0
        ? results.hits.map((hit) =>
            contractorPropsController(
              hit,
              agentServices,
              qualifications,
              savedLocation[0]?.geometry?.location,
            ),
          )
        : [],
    total: results?.nbHits,
    maxRadius: distanceToLocalStr(maxRadius, true),
    onCtaClick,
  };
  return <ContinueSearch {...continueSearchProps} />;
};

export default ContinueSearchContainer;
